<template>
  <div class="theme-editor__panel__field">
    <label :for="inputId" class="theme-editor__panel__field__label">
      {{ label }}
    </label>
    <div class="theme-editor__panel__field__input-group">
      <input
        :id="`${inputId}Picker`"
        type="color"
        :value="modelValue"
        @input="handleColorInput"
        class="theme-editor__panel__field__color-input"
      />
      <input
        :id="inputId"
        type="text"
        :value="modelValue"
        @input="handleTextInput"
        class="theme-editor__panel__field__text-input"
        :placeholder="placeholder"
      />
    </div>
    <div v-if="showCheckbox" class="theme-editor__panel__field__checkbox-group">
      <input
        type="checkbox"
        :id="checkboxId"
        :checked="checkboxValue"
        @change="handleCheckboxChange"
        class="theme-editor__panel__field__checkbox"
      />
      <label :for="checkboxId" class="theme-editor__panel__field__checkbox-label">
        {{ checkboxLabel }}
      </label>
    </div>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  inputId: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '#000000',
  },
  showCheckbox: {
    type: Boolean,
    default: false,
  },
  checkboxValue: {
    type: Boolean,
    default: false,
  },
  checkboxLabel: {
    type: String,
    default: '',
  },
  checkboxId: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'update:checkboxValue']);

const handleColorInput = (event) => {
  emit('update:modelValue', event.target.value);
};

const handleTextInput = (event) => {
  emit('update:modelValue', event.target.value);
};

const handleCheckboxChange = (event) => {
  emit('update:checkboxValue', event.target.checked);
};
</script>

<style lang="scss" scoped>
// Styles are inherited from parent ThemeEditor component
</style>
